import { useEffect, useState } from "react";
import App from "../App";
import { SUPPORT_PREVIEW_PARENT, isSupportPreviewMessage, setSupportPreview, type SupportPreviewSnapshot } from "../lib/supportPreview";
import "./support-preview.css";

export function SupportPreview() {
  const [view, setView] = useState<SupportPreviewSnapshot | null>(null);

  useEffect(() => {
    const receive = (event: MessageEvent) => {
      if (window.parent === window || !isSupportPreviewMessage(event, window.parent)) return;
      setSupportPreview(event.data.snapshot);
      setView(event.data.snapshot);
    };
    window.addEventListener("message", receive);
    if (window.parent !== window) window.parent.postMessage({ type: "precision-support-preview-ready" }, SUPPORT_PREVIEW_PARENT);
    return () => {
      window.removeEventListener("message", receive);
      setSupportPreview(null);
    };
  }, []);

  if (!view) return <main className="support-preview-loading"><span />A preparar a aplicação do cliente…</main>;
  return <div className="support-preview-shell" data-support-preview="true">
    <aside className="support-preview-banner"><strong>Só leitura</strong><span>Aplicação real de {view.account.firstName || "cliente"} · nenhuma alteração será guardada</span></aside>
    <App />
  </div>;
}
